



































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '@/components/base-component.vue';
import { cepFormat } from '@/helpers/cepFormat';
import {
  MESSAGE_FILE_NOT_SELECTED,
  MESSAGE_INVALID_FILE,
  MESSAGE_INVALID_SIZE,
  MESSAGE_FILE_SIZE_EXCEEDED,
} from '@/settings/consts/messages';
import {
  IMAGE_MIME_TYPES,
  EXTENSIONS_MIME_TYPE,
  IMAGE_WIDTH,
  IMAGE_HEIGHT,
} from '@/settings/consts/file-upload';

@Component
export default class UiFileUpload extends BaseComponent {
  @Prop()
  public value: any;
  @Prop({
    default: null,
  })
  public currentFileUrl: string;
  @Prop({
    default: 'Arquivo',
  })
  public label: string;
  @Prop({
    default: () => [],
  })
  public rules: any[];
  @Prop({
    default: false,
  })
  public disabled: boolean;
  @Prop({
    default: () => [],
  })
  public validTypes: string[];
  @Prop({
    default: 2000,
  })
  public maxFileSize: number;

  @Prop({
    default: false,
  })
  public hideLabels: boolean;

  @Prop({
    default: true,
  })
  public validateImgDimensions: boolean;

  public $refs = {
    inputFile: null,
  };

  public inputMessage: string = MESSAGE_FILE_NOT_SELECTED;
  public isLoading: boolean = false;
  public file: any = null;
  public fileUrl: any = null;
  public acceptFiles: string = null;

  get maxFileSizeLabel(): string {
    if (!!this.maxFileSize) {
      const sizeToMb = () => (this.maxFileSize / 1000).toFixed(1);
      return `${sizeToMb()} Mb`;
    } else {
      return '';
    }
  }

get ImageHeight(): string{
   return IMAGE_HEIGHT.toString();
}

get ImageWight(): string{
   return IMAGE_WIDTH.toString();
}
  get fileTypesLabel(): string {
    if (!!this.validTypes.length) {
      const extensions = [];

      for (const extension in EXTENSIONS_MIME_TYPE) {
        if (EXTENSIONS_MIME_TYPE.hasOwnProperty(extension)) {
          const mimeTypes = EXTENSIONS_MIME_TYPE[extension];
          const NOT_FOUND = -1;
          const isMimeType = () =>
            mimeTypes.some(
              (mimeType) => this.validTypes.indexOf(mimeType) !== NOT_FOUND,
            );
          if (isMimeType()) {
            extensions.push(extension);
          }
        }
      }

      return extensions.join(', ');
    } else {
      return '';
    }
  }

  @Watch('currentFileUrl')
  public onCurrentFileUrlChange(val): void {
    this.file = null;
    this.inputMessage = MESSAGE_FILE_NOT_SELECTED;
    this.fileUrl = null;
    this.$refs.inputFile.value = null;
  }

  @Watch('value')
  public onValueChange(val): void {
    this.file = val;
    if (!val) {
      this.inputMessage = MESSAGE_FILE_NOT_SELECTED;
      this.fileUrl = null;
      this.$refs.inputFile.value = null;
    }
  }

  @Watch('validTypes')
  public onValidtypes(val): void {
    this.acceptFiles = val.join(', ');
  }

  public onPickFile(): void {
    this.$refs.inputFile.click();
  }

  public onViewFile(fileUrl: string): void {
    if (!!fileUrl) {
      const fileWindow = window.open(fileUrl, '_blank');
      fileWindow.document.write(
        `<iframe style="border:0" width="100%" height="100%" src="${fileUrl}"></iframe>`,
      );
    }
  }

  public onRemoveFile(): void {
    this.file = null;
    this.inputMessage = MESSAGE_FILE_NOT_SELECTED;
    this.$refs.inputFile.value = null;
    this.$emit('input', this.file);
    this.$emit('removeFile');
  }

  public onRemoveCurrentFile(): void {
    this.$emit('removeFile');
  }

  public onSelectFile(event): void {
    const files = event.target.files;
    const file = !!files.length ? files[0] : null;
    this.file = null;

    let reader = new FileReader();
    reader.readAsDataURL(file);
    var img = new Image();
    var target: any;
    reader.onload = evt => {
      img.onload = () => {
        //refatorar com variavel
        if(this.validateImgDimensions && img.width >= IMAGE_WIDTH && img.height >= IMAGE_HEIGHT){
          this.inputMessage = MESSAGE_INVALID_SIZE;
          this.file = null;
        }
      }
      target = evt.target;
      img.src = target.result.toString();
    }

    if (!!file) {
      if (!this.isValidFileSize(file.size)) {
        this.inputMessage = MESSAGE_FILE_SIZE_EXCEEDED;
      } else if (!this.isValidFileType(file.type)) {
        this.inputMessage = MESSAGE_INVALID_FILE;
      } else {
        this.inputMessage = file.name;
        const fr = new FileReader();
        fr.readAsDataURL(file);
        fr.addEventListener('load', () => {
          this.fileUrl = fr.result;
        });
        this.file = file;
      }
    } else {
      this.inputMessage = MESSAGE_FILE_NOT_SELECTED;
    }

    this.$emit('input', this.file);
  }

  public isDisabled(): boolean {
    return this.disabled || this.isLoading;
  }

  public isImageFile(type): boolean {
    const imagesTypes = IMAGE_MIME_TYPES;
    return imagesTypes.some(
      (item) => item.toLowerCase() === type.toLowerCase(),
    );
  }

  private isValidFileType(type: string): boolean {
    return (
      !this.validTypes.length ||
      this.validTypes.some((item) => item.toLowerCase() === type.toLowerCase())
    );
  }

  private isValidFileSize(size: number): boolean {
    const fileSizeToKb = () => size / 1000;
    return !this.maxFileSize || this.maxFileSize >= fileSizeToKb();
  }
}
